import { render, staticRenderFns } from "./Cfop.vue?vue&type=template&id=304bbae4"
import script from "./Cfop.vue?vue&type=script&lang=js"
export * from "./Cfop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports